export const wppQuotationDefaultWppText = `Olá *{{supplierName}}*, tudo bem?
\nAbaixo está o link para acessar a cotação
\n{{quotationUrl}}`;

type WppTextFormatOptions = {
  wppText?: string;
  quotationUrl?: string;
  supplierName?: string;
};

export function wppQuotationTextFormat({
  wppText,
  quotationUrl,
  supplierName,
}: WppTextFormatOptions) {
  return wppText
    ?.replaceAll('{{quotationUrl}}', quotationUrl || '-')
    .replaceAll('{{supplierName}}', supplierName || '-');
}
